module.exports = __webpack_public_path__ + "static/media/BlingV3_03.ff5846af.png";